import { Link } from "react-router-dom";
// import { Whitelogo } from "constants/Images";
import {logo2,} from 'constants/Images'

function Footer(props) {
  return (
  
  <footer
          class="text-center text-lg-start text-white rounded-3 mt-5"
          >
    
    <div class="container p-4 pb-0">
      
      <section class="pb-3">
        
        <div class="row">
          
          <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3 mx-auto">
            <div class="px-3 py-3 bg-white footer-logo mx-auto">
             
            <img src={logo2} class="w-100 h-100"/>
            </div>
           
          </div>
          

          <hr class="w-100 clearfix d-md-none mt-4" />

          
         
          

          {/* <hr class="w-100 clearfix d-md-none" /> */}

          
          <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
            <h6 class="text-uppercase mb-4 font-weight-bold ">
              Useful links
            </h6>
            <p>
              <a class="text-white  fs-sm-14">Your Account</a>
            </p>
            <p>
              <a class="text-white fs-sm-14">Become an Affiliate</a>
            </p>
            <p>
              <a class="text-white fs-sm-14">Shipping Rates</a>
            </p>
            <p>
              <a class="text-white fs-sm-14">Help</a>
            </p>
          </div>

          
          <hr class="w-100 clearfix d-md-none" />

          
          <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
            <h6 class="text-uppercase mb-4 font-weight-bold ">Contact</h6>
            <p  className="fs-sm-14"><i class="fas fa-home mr-3"></i> New York, NY 10012, US</p>
            <p className="fs-sm-14"><i class="fas fa-envelope mr-3"></i> info@gmail.com</p>
            <p className="fs-sm-14"><i class="fas fa-phone mr-3"></i> + 01 234 567 88</p>
            <p className="fs-sm-14"><i class="fas fa-print mr-3"></i> + 01 234 567 89</p>
          </div>
          
        </div>
        
      </section>
      


      
      <section class="p-3 pt-0 d-none">
        <div class="row d-flex align-items-center">
          
          <div class="col-md-7 col-lg-8 text-center text-md-start">
            <div class="p-3">
              © 2020 Copyright:
              <a class="text-white" href="https://mdbootstrap.com/"
                 >GSP Golden Star Paints</a>
            </div>
          </div>
          

          
          <div class="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
            <a
               class="btn btn-outline-light btn-floating m-1"
               role="button"
               ><i class="fab fa-facebook-f"></i
              ></a>

            <a
               class="btn btn-outline-light btn-floating m-1"
               role="button"
               ><i class="fab fa-twitter"></i
              ></a>

            <a
               class="btn btn-outline-light btn-floating m-1"
               role="button"
               ><i class="fab fa-google"></i
              ></a>

            
            <a
               class="btn btn-outline-light btn-floating m-1"
               role="button"
               ><i class="fab fa-instagram"></i
              ></a>
          </div>
          
        </div>
      </section>
      
    </div>
    
  </footer>
  
  );
}

export default Footer;
